import { render } from "./HorizontalProgramCardLoader.vue?vue&type=template&id=36360d09"
import script from "./HorizontalProgramCardLoader.vue?vue&type=script&lang=js"
export * from "./HorizontalProgramCardLoader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-mtn-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__